module.exports = __webpack_public_path__ + "img/WhatsAppGreen.898ba7d.svg";